import { joinURL } from 'ufo'
import type { ProviderGetImage } from '@nuxt/image'

export const getImage: ProviderGetImage = (src, { modifiers = {}, baseURL } = {}) => {
  const config = useRuntimeConfig()
  return {
    url: joinURL(config.app.cdnURL || '/', src),
  }
}
